import { render } from "./Consultation.vue?vue&type=template&id=7b88f828&scoped=true"
import script from "./Consultation.vue?vue&type=script&lang=js"
export * from "./Consultation.vue?vue&type=script&lang=js"

import "./Consultation.vue?vue&type=style&index=0&id=7b88f828&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b88f828"]])

export default __exports__